module.exports = __webpack_public_path__ + "img/InstrumentsImg@2x.e15fbe7c.png";